import { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';

import ButtonSolid from 'UiKit/button/buttonSolid';
import { Condition } from 'Component/others';
import usePostGenerateSchedule from 'Domain/schedule-generate/usePostGenerateSchedule';

import GenerateResultTab from 'View/schedule-generate/component/generate-result-tab';
import GenerateResultCalendar from 'View/schedule-generate/component/generate-result-calendar';
import GenerateResultHead from 'View/schedule-generate/component/generate-result-head';
import GenerateResultRecap from 'View/schedule-generate/component/generate-result-recap';
import TutorialModal from 'View/schedule-generate/component/tutorial-modal';
import { useScheduleGenerateState } from 'View/schedule-generate/state';
import useConfirmationModal from 'View/schedule-generate/hooks/useConfimationModal';

import styles from './styles.module.css';

const GenerateResult = () => {
  const { t } = useTranslation('schedule-generate');
  const { accounts, generateResultData, selectedTab, openTutorialModal, updateState } = useScheduleGenerateState();
  const { mutate } = usePostGenerateSchedule();
  const { onOpenModalConfirmationSubmit } = useConfirmationModal();

  const handleSubmit = () => {
    onOpenModalConfirmationSubmit({
      onConfirm: () => {
        mutate({
          ...generateResultData,
          accounts,
        });
      },
    });
  };

  useEffect(() => {
    const cookies = new Cookies();
    const hasViewedTutorial = cookies.get('smart-schedule-tutorial') === 'viewed';
    updateState({ openTutorialModal: !hasViewedTutorial });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box className={styles['generate-result__container']}>
      {/* Head  */}
      <Box className={styles['generate-result__section--head']}>
        <GenerateResultHead />
      </Box>

      {/* Body  */}
      <Box className={styles['generate-result__section--body']}>
        <Box className={styles['tab__container']}>
          <GenerateResultTab />
        </Box>

        <Box className={styles['calendar__container']}>
          <Condition children={<GenerateResultCalendar />} statement={selectedTab !== 'recap'} fallback={<GenerateResultRecap />} />
        </Box>
      </Box>

      {/* Footer  */}
      <Box className={styles['generate-result__section--footer']}>
        <ButtonSolid onClick={handleSubmit}>{t('buttonSaveText')}</ButtonSolid>
      </Box>

      <Condition statement={openTutorialModal}><TutorialModal /></Condition>
    </Box>
  );
};

export default GenerateResult;
